import React from 'react'

import { LntDivider, LntSwitch } from '@app/components/base'

import styles from './styles.module.scss'

import type { ExcludedRenderProps } from './types'

export const ExcludedRender: React.FC<ExcludedRenderProps> = ({ isExcluded, menu, onChange }) => {
  return (
    <div className={ styles.excludedRenderer }>
      { menu }

      <LntDivider />

      <LntSwitch
        checked={ isExcluded }
        onChange={ onChange }
      >
        Кроме
      </LntSwitch>
    </div>
  )
}
